import React, { useState } from 'react';
import { Download } from 'lucide-react';
import * as XLSX from 'xlsx';
import toast from 'react-hot-toast';
import { TRUNCATED_MESSAGE } from '../utils/exportReport';

export interface ExportResult {
  workbook: XLSX.WorkBook;
  truncated?: boolean;
}

interface ExportButtonProps {
  onExport: () => Promise<ExportResult>;
  fileName: string;
}

const ExportButton: React.FC<ExportButtonProps> = ({ onExport, fileName }) => {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    setBusy(true);
    try {
      const { workbook, truncated } = await onExport();
      XLSX.writeFile(workbook, fileName);
      // Vẫn tải phần đã có, chỉ cảnh báo là thiếu dòng
      if (truncated) toast(TRUNCATED_MESSAGE, { icon: '⚠️' });
    } catch (error) {
      toast.error(error instanceof Error && error.message ? error.message : 'Xuất báo cáo thất bại');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={busy}
      className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <Download className="h-4 w-4" aria-hidden="true" />
      {busy ? 'Đang xuất…' : 'Xuất Excel'}
    </button>
  );
};

export default ExportButton;
